import {
  InsuranceMonitor,
  InsuranceMonitorStatus
} from "@wingspanhq/wingspan-api-sdk";

/**
 * Whether the monitor has yet to reach a decision.
 *
 * `Pending` is "the payee has not shared coverage yet" and `Monitoring` is
 * "matching is running against their policies" — the two halves of what the
 * pre-3.13.0 SDK collapsed into a single `Active` member. `Complete` (a
 * coverage satisfied every requirement) and `ForceMatched` (a coverage was
 * linked manually and failed validation) are the terminal states.
 */
export const selectorIsInsuranceMonitorInProgress = (
  monitor: InsuranceMonitor | undefined
) =>
  monitor?.status === InsuranceMonitorStatus.PENDING ||
  monitor?.status === InsuranceMonitorStatus.MONITORING;
